var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcIcon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 229.24 283.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#ea78a4;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-icon3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_38_copia_11",
    "data-name": "38 copia 11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "alerta_aproximaci\\xF3n"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 114.3,
    cy: 114.11,
    r: 105.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129,178.13h-.15a51,51,0,0,1-46.32-29.92,2.84,2.84,0,0,1,5.18-2.33,45.33,45.33,0,0,0,41.16,26.57H129A45,45,0,0,0,146.6,85.93a2.84,2.84,0,0,1,2.21-5.23A50.72,50.72,0,0,1,129,178.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.24,132.28h9.42v19.06h-9.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.65,108.35h9.4v19h-9.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.24,127.4h-9.39v-19h9.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M55.36,134.85c-.75.84-1.49,1.72-2.3,2.54q-2.93,3-5.89,5.88a2.32,2.32,0,0,1-3.39.28c-1-.94-.9-2.32.23-3.46q3.69-3.72,7.39-7.4a9.25,9.25,0,0,1,1.11-.8,21.39,21.39,0,0,1-4.44-9.5,20.42,20.42,0,0,1,5.46-18.53c4.39-4.61,9-9,13.51-13.51,1.25-1.23,2.45-1.21,3.72.05,1.86,1.85,3.7,3.71,5.72,5.75,1.76-1.82,3.44-3.58,5.15-5.31s3.17-3.18,4.79-4.75A2.23,2.23,0,0,1,89.8,86a2.21,2.21,0,0,1-.23,3.29c-3,3-6,6-9.07,9-.26.26-.51.53-.78.81l8.71,8.39s.33-.3.61-.58q4.62-4.61,9.24-9.2a2.19,2.19,0,0,1,2.85-.47,2.11,2.11,0,0,1,1,2.51,3.81,3.81,0,0,1-.92,1.37q-4.44,4.47-8.91,8.89a8.26,8.26,0,0,1-1.07.78l5.62,5.6c1.52,1.52,1.51,2.57,0,4.11q-6.28,6.27-12.58,12.54c-8,7.9-19.13,8.75-28.24,2.17ZM69,95.18c-4.28,4.13-8.66,8.07-12.68,12.35a15.24,15.24,0,0,0-3.79,14.28A15.88,15.88,0,0,0,64,134.35c6.29,1.92,11.95.42,16.69-4.13,3.25-3.11,6.37-6.34,9.56-9.51.74-.73,1.53-1.43,2.19-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M129,55.34l7.7-7.7c.27-.27.53-.54.81-.79A2.23,2.23,0,1,1,140.59,50c-.52.58-1.1,1.12-1.66,1.67l-6.81,6.77c.2.3.35.54.53.78A21,21,0,0,1,131,86.34c-4.42,4.63-9,9.08-13.58,13.6a2.28,2.28,0,0,1-3.64,0Q100.6,86.8,87.43,73.64a2.27,2.27,0,0,1,0-3.63c4.48-4.48,8.91-9,13.47-13.4a21.15,21.15,0,0,1,27.24-1.86ZM92.15,71.51,115.7,95.16c4.08-4,8.35-8,12.32-12.21a15.47,15.47,0,0,0,3.92-14.47A15.89,15.89,0,0,0,120.5,55.93c-6.24-1.92-11.87-.46-16.61,4-2.86,2.7-5.58,5.55-8.38,8.31C94.35,69.43,93.14,70.55,92.15,71.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.62,17.85a96.77,96.77,0,0,1,68.43,165.2A96.77,96.77,0,1,1,46.2,46.2a96.1,96.1,0,0,1,68.42-28.35m0-17.85A114.62,114.62,0,1,0,229.24,114.62,114.62,114.62,0,0,0,114.62,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "114.78 283.46 166.93 216.38 62.32 216.38 114.78 283.46"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcIcon3);
export default __webpack_public_path__ + "static/media/ic-icon3.f4dc7ddb57155f6072d3513ddcc71029.svg";
export { ForwardRef as ReactComponent };